import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1a02250e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "has-background-primary py-2 nav-container" }
const _hoisted_2 = {
  class: "navbar is-primary",
  role: "navigation",
  "aria-label": "main navigation"
}
const _hoisted_3 = { class: "navbar-brand" }
const _hoisted_4 = ["title"]
const _hoisted_5 = ["src", "alt"]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, null, -1))
const _hoisted_9 = [
  _hoisted_6,
  _hoisted_7,
  _hoisted_8
]
const _hoisted_10 = { class: "navbar-start" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["title", "onClick"]
const _hoisted_13 = {
  key: 2,
  class: "navbar-dropdown is-boxed"
}
const _hoisted_14 = ["title", "onClick"]
const _hoisted_15 = { class: "navbar-end" }
const _hoisted_16 = { class: "navbar-item" }
const _hoisted_17 = { class: "buttons" }
const _hoisted_18 = ["title", "href"]
const _hoisted_19 = ["title", "href"]
const _hoisted_20 = ["title", "href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!
  const _component_BaseGridContainer = _resolveComponent("BaseGridContainer")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BaseGridContainer, null, {
      default: _withCtx(() => [
        _createElementVNode("nav", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("a", {
              class: "navbar-item",
              href: "#",
              title: _ctx.t('APP_TITLE'),
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goHome && _ctx.goHome(...args)))
            }, [
              _createElementVNode("img", {
                src: _ctx.logo,
                alt: _ctx.t('APP_TITLE')
              }, null, 8, _hoisted_5)
            ], 8, _hoisted_4),
            _createElementVNode("a", {
              role: "button",
              class: _normalizeClass(['navbar-burger', _ctx.isActive ? 'is-active' : '']),
              "aria-label": "menu",
              "aria-expanded": "false",
              "data-target": "mainNavigation",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.toggleMenu && _ctx.toggleMenu(...args)))
            }, _hoisted_9, 2)
          ]),
          _createElementVNode("div", {
            id: "mainNavigation",
            class: _normalizeClass(['navbar-menu', _ctx.isActive ? 'is-active' : ''])
          }, [
            _createElementVNode("div", _hoisted_10, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuItems, (item, index) => {
                return (_openBlock(), _createElementBlock("a", {
                  class: _normalizeClass(`${_ctx.navItemClasses(item.children)} ${_ctx.isActiveSub[item.id] ? 'is-active' : ''}`),
                  key: index
                }, [
                  (!item.children)
                    ? (_openBlock(), _createElementBlock("span", {
                        key: 0,
                        onClick: ($event: any) => (_ctx.openPage(item.object_slug, item.object, item.url))
                      }, _toDisplayString(item.title), 9, _hoisted_11))
                    : _createCommentVNode("", true),
                  (item.children)
                    ? (_openBlock(), _createElementBlock("a", {
                        key: 1,
                        class: "navbar-link",
                        title: item.title,
                        onClick: ($event: any) => (_ctx.toggleDropDown(item.id))
                      }, _toDisplayString(item.title), 9, _hoisted_12))
                    : _createCommentVNode("", true),
                  (item.children && _ctx.isActiveSub[item.id])
                    ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, (subItem, subIndex) => {
                          return (_openBlock(), _createElementBlock("a", {
                            key: subIndex,
                            class: "navbar-item",
                            title: subItem.title,
                            onClick: ($event: any) => (_ctx.openPage(subItem.object_slug, subItem.object, subItem.url))
                          }, _toDisplayString(subItem.title), 9, _hoisted_14))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ], 2))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("a", {
                    class: "button is-primary",
                    title: _ctx.t('SOCIAL_MEDIA.INSTAGRAM'),
                    href: _ctx.t('SOCIAL_MEDIA.INSTAGRAM_URL'),
                    target: "_blank"
                  }, [
                    _createVNode(_component_BaseIcon, { name: "fa-brands fa-instagram" })
                  ], 8, _hoisted_18),
                  _createElementVNode("a", {
                    class: "button is-primary",
                    title: _ctx.t('SOCIAL_MEDIA.TWITTER'),
                    href: _ctx.t('SOCIAL_MEDIA.TWITTER_URL'),
                    target: "_blank"
                  }, [
                    _createVNode(_component_BaseIcon, { name: "fa-brands fa-twitter" })
                  ], 8, _hoisted_19),
                  _createElementVNode("a", {
                    class: "button is-primary",
                    title: _ctx.t('SOCIAL_MEDIA.FACEBOOK'),
                    href: _ctx.t('SOCIAL_MEDIA.FACEBOOK_URL'),
                    target: "_blank"
                  }, [
                    _createVNode(_component_BaseIcon, { name: "fa-brands fa-facebook-square" })
                  ], 8, _hoisted_20)
                ])
              ])
            ])
          ], 2)
        ])
      ]),
      _: 1
    })
  ]))
}